/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';

import { NotificationCategoryFragmentDoc } from '../../../graphql/fragments/NotificationCategory.generated';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetOrderStatusNotificationPreferencesQueryVariables = Exact<{ [key: string]: never }>;

export type GetOrderStatusNotificationPreferencesQuery = {
  readonly getOrderStatusNotificationPreferences: {
    readonly __typename: 'NotificationCategory';
    readonly id: string;
    readonly displayName: string;
    readonly emailSubscribe: boolean;
    readonly pushSubscribe: boolean;
    readonly hasResolved: boolean;
  };
};

export const GetOrderStatusNotificationPreferencesDocument = gql`
  query GetOrderStatusNotificationPreferences {
    getOrderStatusNotificationPreferences {
      ...notificationCategory
    }
  }
  ${NotificationCategoryFragmentDoc}
`;

export function useGetOrderStatusNotificationPreferencesQuery(
  options?: Omit<Urql.UseQueryArgs<GetOrderStatusNotificationPreferencesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    GetOrderStatusNotificationPreferencesQuery,
    GetOrderStatusNotificationPreferencesQueryVariables
  >({ query: GetOrderStatusNotificationPreferencesDocument, ...options });
}
